import { render, staticRenderFns } from "./templatedit.vue?vue&type=template&id=7d84a1d4"
import script from "./templatedit.vue?vue&type=script&lang=js"
export * from "./templatedit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports